import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="container text-center">
        <span className="col-3">
          <a href="https://testing.languagetechnology.org" className="link-black" target="_blanc">
            testing.languagetechnology.org
          </a>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
